import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=6e78a9f4&"
import script from "./PageContent.vue?vue&type=script&lang=js&"
export * from "./PageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e78a9f4')) {
      api.createRecord('6e78a9f4', component.options)
    } else {
      api.reload('6e78a9f4', component.options)
    }
    module.hot.accept("./PageContent.vue?vue&type=template&id=6e78a9f4&", function () {
      api.rerender('6e78a9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page-content/PageContent.vue"
export default component.exports